/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const DialogueCircledIcon = /*#__PURE__*/ createSvgIcon(
  'DialogueCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M8.177 14.219c-.304 0-.562-.106-.775-.32a1.055 1.055 0 01-.319-.774v-.73h6.928V7.657h.729c.303 0 .562.107.774.32.213.212.32.47.32.774v6.335a.512.512 0 01-.335.51.499.499 0 01-.594-.117l-1.26-1.26H8.178zm-1.824-2.917l-1.258 1.26a.498.498 0 01-.594.116.515.515 0 01-.334-.513V5.833c0-.303.106-.562.319-.774.212-.213.47-.32.775-.32h6.562c.304 0 .562.107.775.32.212.212.319.47.319.774v4.375c0 .304-.107.562-.32.775-.212.213-.47.32-.774.32h-5.47zm5.47-1.094V5.833H5.26v4.375h6.563z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default DialogueCircledIcon;
